import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  CreateCommentTemplateRequest,
  UpdateCommentTemplateRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const createCommentTemplates = async (
  instance: AxiosInstance,
  organizationId: string,
  params: CreateCommentTemplateRequest
) => {
  return await userApiDefaultApiFactory(instance).createCommentTemplate({
    createCommentTemplateRequest: params,
    organizationId,
  })
}

export const deleteCommentTemplate = async (
  instance: AxiosInstance,
  organizationId: string,
  commentTemplateId: string
) => {
  return await userApiDefaultApiFactory(instance).deleteCommentTemplate({
    organizationId,
    templateId: commentTemplateId,
  })
}

export const getCommentTemplate = async (
  instance: AxiosInstance,
  organizationId: string,
  commentTemplateId: string
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getCommentTemplatesCommentTemplateId({
    organizationId,
    templateId: commentTemplateId,
  })
}

export const getCommentTemplates = async (
  instance: AxiosInstance,
  organizationId: string
) => {
  return await userApiDefaultApiFactory(instance).getCommentTemplates({
    organizationId,
  })
}

export const updateCommentTemplate = async (
  instance: AxiosInstance,
  organizationId: string,
  commentTemplateId: string,
  params: UpdateCommentTemplateRequest
) => {
  return await userApiDefaultApiFactory(instance).updateCommentTemplate({
    updateCommentTemplateRequest: params,
    organizationId,
    templateId: commentTemplateId,
  })
}

// Do Not Remove this line ===@import api client===
